import { defineStore } from 'pinia'
import { reactive, computed } from 'vue'
import { getInitialState, resetState } from './state'
import { createActions } from './actions'
import { createGetters } from './getters'

export const useOrganizationsStore = defineStore('organizations', () => {
  const state = reactive(getInitialState())
  const actions = createActions(state)
  const getters = createGetters(state)

  // Reset function for security - clears all data on logout/tenant switch
  const $reset = () => {
    resetState(state)
  }

  return {
    // State
    organizations: computed(() => state.organizations),
    selectedOrganization: computed(() => state.selectedOrganization),
    isLoading: computed(() => state.isLoading),
    error: computed(() => state.error),
    filters: computed(() => state.filters),

    // Getters
    filteredOrganizations: computed(() => getters.filteredOrganizations()),
    activeOrganizations: computed(() => getters.activeOrganizations()),
    totalOrganizations: computed(() => getters.totalOrganizations()),
    totalActiveOrganizations: computed(() => getters.totalActiveOrganizations()),
    getOrganizationById: getters.getOrganizationById,

    // Actions
    ...actions,

    // Reset
    $reset,
  }
})
